import React, { useState, useContext } from "react";
import Input from "@mui/joy/Input";
import Button from "@mui/material/Button";
import { ThemeProvider } from "@mui/material/styles";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import theme from "../../../themes/theme";
import Textarea from "@mui/joy/Textarea";
import image from "../../../images/image 5.png";
import "./CreateCourse.css";
import AdminLayout from "../../../components/AdminDashboard/AdminLayout/AdminLayout";
import { AppContext } from "../../../context/AppContext";
import BASE_URL from "../../../config/api";
import ImageUploadPreview from "../../../components/AdminDashboard/ImageUpload/ImageUpload";

export default function CreateCourse() {
  const [courseInput, setCourseInput] = useState({
    title: "",
    description: "",
    instructor: "",
    rating: "",
    image: null,
  });
  const { token } = useContext(AppContext);
  const [message, setMessage] = useState("");
  const [incorrectStyles, setIncorrectStyles] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const colorMessage = incorrectStyles ? "#f00" : "#000";

  const handleCreateCourse = async () => {
    try {
      const formData = new FormData();
      formData.append("image", courseInput.image);

      formData.append("title", courseInput.title);
      formData.append("description", courseInput.description);
      formData.append("instructor", courseInput.instructor);
      formData.append("rating", courseInput.rating);

      const response = await axios.post(`${BASE_URL}/courses`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
      const courseInfo = response.data;

      toast.success("Course created");
      window.location.href = `/admin/:id`;
      setIncorrectStyles(false);
      setIsSuccess(true);
      setMessage("Course created successfully!");
      setCourseInput({
        title: "",
        description: "",
        instructor: "",
        rating: "",
        image: null,
      });
    } catch (err) {
      toast.error(err);
      toast.error("Please fill in all required fields correctly.");
      setIsSuccess(false);
      setIncorrectStyles(true);
      setMessage(err.response ? err.response.data.err : err.message);
    }
  };
  const handleDescriptionChange = (e) => {
    const inputValue = e.target.value;

    if (inputValue.length <= 100) {
      setCourseInput((prev) => ({
        ...prev,
        description: inputValue,
      }));
    }
  };

  return (
    <AdminLayout>
      <div className="create-course-wrapper">
        {isSuccess ? (
          <div className="container-success">
            <h2 style={{ textAlign: "center", color: colorMessage }}>{message && message}</h2>
          </div>
        ) : (
          <form className="create-form-wrapper">
            <p className="title">Create a New Course</p>
            <div className="main-container">
              <div className="left-container">
                <label>Course Title</label>
                <Input
                  variant="soft"
                  required
                  type="text"
                  placeholder="Insert your course title"
                  name="title"
                  value={courseInput.title}
                  onChange={(e) =>
                    setCourseInput((prev) => ({
                      ...prev,
                      title: e.target.value,
                    }))
                  }
                ></Input>
                <label>Course Description</label>
                <Textarea variant="soft" required minRows={3} maxRows={4} placeholder="Insert short course description (max 100 characters) " name="description" value={courseInput.description} onChange={handleDescriptionChange} />
                <label>Lecturer</label>
                <Input
                  variant="soft"
                  type="text"
                  placeholder="Lecturer"
                  name="instructor"
                  value={courseInput.instructor}
                  onChange={(e) =>
                    setCourseInput((prev) => ({
                      ...prev,
                      instructor: e.target.value,
                    }))
                  }
                ></Input>
                <label>Course level</label>
                <Input
                  variant="soft"
                  required
                  type="text"
                  placeholder="Begginer/Intermediate/Advanced"
                  name="rating"
                  value={courseInput.rating}
                  onChange={(e) =>
                    setCourseInput((prev) => ({
                      ...prev,
                      rating: e.target.value,
                    }))
                  }
                ></Input>
                <div className="create-course-btns">
                  <ThemeProvider theme={theme}>
                    <Button variant="contained" onClick={handleCreateCourse}>
                      Create Course
                    </Button>
                  </ThemeProvider>
                  <p style={{ textAlign: "center", color: colorMessage }}>{message && message}</p>
                </div>
              </div>
              <div className="right-container">
                <label>Course Image</label>
                <ImageUploadPreview
                  imageUrl={courseInput.image || image}
                  onImageChange={(file) =>
                    setCourseInput((prev) => ({
                      ...prev,
                      image: file,
                    }))
                  }
                />
                <p>*only JPG files are allowed</p>
              </div>
            </div>
            <ToastContainer position="bottom-right" autoClose={5000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} />
          </form>
        )}
      </div>
    </AdminLayout>
  );
}
